export const WALLET_SUCCESS_GET_SALDO = "WALLET_SUCCESS_GET_SALDO";
export const WALLET_PENDING_GET_SALDO = "WALLET_PENDING_GET_SALDO";
export const WALLET_ERROR_GET_SALDO = "WALLET_ERROR_GET_SALDO";


export const WALLET_OPEN_PAYMENT_MODAL = "WALLET_OPEN_PAYMENT_MODAL";